import {Column, HeaderProps} from 'react-table'
import { useListView } from '../../core/ListViewProvider'
import {UserCustomHeader} from './UserCustomHeader'
import pencil from '../../../../../../icons/pencil.svg'
import { UniversalContent } from '../../../../../components/Table/table/columns/UniversalProps'
import { TableCustomHeader } from '../../../../../components/Table/table/columns/TableCustomHeader'

export type Grade = {
  id: string,
  key: string,
  en: string,
  et: string,
  lv: string,
  es: string,
  pt: string,
  fr: string;
  el: string;
  ja: string,
  de: string,
}

const usersColumns: ReadonlyArray<Column<Grade>> = [
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='id' className='min-w-100px' />,
    accessor: 'id',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Key' className='min-w-200px' />,
    accessor: 'key',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='English' className='min-w-200px' />,
    accessor: 'en',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Estonian' className='min-w-200px' />,
    accessor: 'et',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Latvian' className='min-w-200px' />,
    accessor: 'lv',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Spanish' className='min-w-200px' />,
    accessor: 'es',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Portuguese' className='min-w-200px' />,
    accessor: 'pt',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='French' className='min-w-200px' />,
    accessor: 'fr',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Greek' className='min-w-200px' />,
    accessor: 'el',
  },
  {
    Header: (props) => <UserCustomHeader tableProps={props} title='Japanese' className='min-w-200px' />,
    accessor: 'ja',
  },

  {
    Header: (props) => <UserCustomHeader tableProps={props} title='German' className='min-w-200px' />,
    accessor: 'de',
  },
  {
    Header: (props: HeaderProps<UniversalContent>) => (
      <TableCustomHeader tableProps={props} title='UPDATE' className='text-end min-w-100px' />
    ),
    id: 'actions',
    Cell: ({...props}) => {
      const {setItemIdForUpdate} = useListView()

      const openWebhooksInfoModal = ()=> {
        setItemIdForUpdate(props.data[props.row.id])
      }

        return (
          <div onClick={openWebhooksInfoModal}>
            <img alt='' src={pencil} style={{marginRight: 20, cursor: 'pointer'}}/>
          </div>
        )
      },
  },
]

export {usersColumns}
